import "./EventDetailsSkeleton.css";

const EventDetailsSkeleton = () => {
  return (
    <div className="ed-event-skeleton">
      <div className="ed-skeleton-header shimmer" />
      <div className="ed-skeleton-stats">
        {[1, 2, 3, 4].map((i) => (
          <div key={i} className="ed-skeleton-card shimmer" />
        ))}
      </div>
      <div className="ed-skeleton-table shimmer" />
    </div>
  );
};

export default EventDetailsSkeleton;
